import React from 'react';
import {HashLink as Link} from 'react-router-hash-link';
import {Helmet} from 'react-helmet';
import {ArrowRightIcon,GiftIcon,ShieldCheckIcon,GlobeIcon,EyeIcon,AcademicCapIcon} from '@heroicons/react/outline';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFirefoxBrowser,faChrome,faGithub} from '@fortawesome/free-brands-svg-icons';
import addonDemo1 from '../../assets/images/addon-demo1.png';
import addonDemo2 from '../../assets/images/addon-demo2.png';
import addonDemo3 from '../../assets/images/addon-demo3.png';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Translator from '../translator/translator';
import SliderDemo from '../slider-demo/slider-demo';
import CTA from '../cta/cta';
import Footer from '../footer/footer';
const Landing=({globalSettings})=>{
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.landingPageTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar
        globalSettings={globalSettings}
      />
      <div className='pt-16 bg-purple-50'>
        <div className='w-full px-4 sm:px-6 lg:px-8 py-16 md:py-24 flex justify-center'>
          <div className='grid grid-cols-1 min-[945px]:grid-cols-2 gap-12 items-start max-w-[1920px] w-full'>
            <div>
              <h1 className='text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight'>
                {locales.landingHeroTitlePrefix[globalSettings.lang]}
                <span className='text-purple-800'>
                  {locales.landingHeroTitleHighlight[globalSettings.lang]}
                </span>
                {locales.landingHeroTitleSuffix[globalSettings.lang]}
              </h1>
              <p className='mt-4 text-lg sm:text-xl text-gray-600'>
                {locales.landingHeroDescription[globalSettings.lang]}
              </p>
              <div className='mt-8 flex flex-col sm:flex-row gap-4'>
                <Link to={`/${globalSettings.lang}/translator`} className='w-full sm:w-auto'>
                  <button className='w-full bg-purple-800 hover:bg-purple-600 text-white px-6 py-3 rounded-lg text-lg font-medium flex items-center justify-center'>
                    {locales.landingGetStarted[globalSettings.lang]}
                    <ArrowRightIcon className='ml-2 h-5 w-5' />
                  </button>
                </Link>
                <Link to='#browser-extension' className='w-full sm:w-auto'>
                  <button className='w-full bg-white border-2 border-purple-800 text-purple-800 hover:bg-purple-50 px-6 py-3 rounded-lg text-lg font-medium'>
                    {locales.landingLearnMore[globalSettings.lang]}
                  </button>
                </Link>
              </div>
              <div className='mt-12'>
                <SliderDemo
                  globalSettings={globalSettings}
                />
              </div>
            </div>
            <div className='flex justify-center min-[1200px]:justify-start'>
              <Translator
                globalSettings={globalSettings}
              />
            </div>
          </div>
        </div>
      </div>
      <div id='browser-extension' className='py-20 bg-white relative overflow-hidden'>
        <div className='absolute inset-0 opacity-[0.03]' style={{backgroundImage: 'radial-gradient(circle at 2px 2px, rgb(147 51 234) 1px, transparent 0)', backgroundSize: '48px 48px'}}></div>
        <div className='w-full px-4 sm:px-6 lg:px-8 relative'>
          <div className='text-center mb-16'>
            <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-4'>
              {locales.landingExtensionTitle[globalSettings.lang]}
            </h2>
            <p className='mt-6 text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed'>
              {locales.landingExtensionDescription[globalSettings.lang]}
            </p>
          </div>
          <div className='max-w-7xl mx-auto space-y-20 mt-20'>
            <div className='bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl border border-purple-100 p-8 md:p-12 hover:shadow-2xl transition-all duration-300'>
              <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-center'>
                <div className='order-2 lg:order-1 flex justify-center lg:justify-start'>
                  <div className='relative'>
                    <div className='absolute -inset-4 bg-gradient-to-r from-purple-400 to-pink-400 rounded-2xl opacity-20 blur-2xl'></div>
                    <img src={addonDemo1} alt='Extension Popup' className='relative rounded-xl shadow-2xl border-4 border-white max-w-none w-auto h-auto object-none' />
                  </div>
                </div>
                <div className='order-1 lg:order-2 space-y-6'>
                  <h3 className='text-3xl md:text-4xl font-bold text-gray-900'>
                    {locales.landingOneClickActivation[globalSettings.lang]}
                  </h3>
                  <p className='text-gray-700 text-lg leading-relaxed'>
                    {locales.landingOneClickActivationDescription[globalSettings.lang]}
                  </p>
                  <ul className='space-y-3 text-gray-700'>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingPerDomainActivation[globalSettings.lang]}
                      </span>
                    </li>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingLanguageSupport[globalSettings.lang]}
                      </span>
                    </li>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingTryAsGuest[globalSettings.lang]}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl shadow-xl border border-blue-100 p-8 md:p-12 hover:shadow-2xl transition-all duration-300'>
              <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-center'>
                <div className='space-y-6'>
                  <h3 className='text-3xl md:text-4xl font-bold text-gray-900'>
                    {locales.landingRightClickTranslate[globalSettings.lang]}
                  </h3>
                  <p className='text-gray-700 text-lg leading-relaxed'>
                    {locales.landingRightClickTranslateDescription[globalSettings.lang]}
                  </p>
                  <ul className='space-y-3 text-gray-700'>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingSeamlessOverlay[globalSettings.lang]}
                      </span>
                    </li>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingWorksAnywhere[globalSettings.lang]}
                      </span>
                    </li>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingNoDownloadUpload[globalSettings.lang]}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className='flex justify-center lg:justify-end'>
                  <div className='relative'>
                    <div className='absolute -inset-4 bg-gradient-to-r from-blue-400 to-purple-400 rounded-2xl opacity-20 blur-2xl'></div>
                    <img src={addonDemo2} alt='Context Menu' className='relative rounded-xl shadow-2xl border-4 border-white max-w-none w-auto h-auto object-none' />
                  </div>
                </div>
              </div>
            </div>
            <div className='bg-gradient-to-br from-pink-50 to-purple-50 rounded-3xl shadow-xl border border-pink-100 p-8 md:p-12 hover:shadow-2xl transition-all duration-300'>
              <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-center'>
                <div className='order-2 lg:order-1 flex justify-center lg:justify-start'>
                  <div className='relative'>
                    <div className='absolute -inset-4 bg-gradient-to-r from-pink-400 to-purple-400 rounded-2xl opacity-20 blur-2xl'></div>
                    <img src={addonDemo3} alt='Translation Engines' className='relative rounded-xl shadow-2xl border-4 border-white max-w-none w-auto h-auto object-none' />
                  </div>
                </div>
                <div className='order-1 lg:order-2 space-y-6'>
                  <h3 className='text-3xl md:text-4xl font-bold text-gray-900'>
                    {locales.landingRealTimeEngines[globalSettings.lang]}
                  </h3>
                  <p className='text-gray-700 text-lg leading-relaxed'>
                    {locales.landingRealTimeEnginesDescription[globalSettings.lang]}
                  </p>
                  <ul className='space-y-3 text-gray-700'>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingTwoRealTimeEngines[globalSettings.lang]}
                      </span>
                    </li>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingFourPremiumModels[globalSettings.lang]}
                      </span>
                    </li>
                    <li className='flex items-start group'>
                      <span className='flex-shrink-0 h-6 w-6 rounded-full bg-purple-800 text-white flex items-center justify-center mr-3 text-sm font-bold group-hover:scale-110 transition-transform'>✓</span>
                      <span className='text-lg'>
                        {locales.landingFlexiblePricing[globalSettings.lang]}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className='mt-24 text-center'>
            <div className='max-w-4xl mx-auto bg-gradient-to-br from-purple-800 to-purple-900 rounded-3xl shadow-2xl p-10 md:p-12 border border-purple-700'>
              <h3 className='text-3xl md:text-4xl font-bold text-white mb-4'>
                {locales.landingGetExtension[globalSettings.lang]}
              </h3>
              <p className='text-purple-100 text-lg mb-8'>
                {locales.landingStartTranslatingToday[globalSettings.lang]}
              </p>
              <div className='flex flex-col md:flex-row gap-4 justify-center items-center'>
                <a href='https://addons.mozilla.org/firefox/addon/nekotranslate/' target='_blank' rel='noopener noreferrer' className='w-full md:w-auto'>
                  <button className='w-full md:w-auto bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-10 py-4 rounded-xl text-lg font-semibold flex items-center justify-center gap-3 shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-200'>
                    <FontAwesomeIcon icon={faFirefoxBrowser} className='w-6 h-6' />
                    {locales.landingAddToFirefox[globalSettings.lang]}
                  </button>
                </a>
                <a href='https://chromewebstore.google.com/detail/nekotranslate/bfnogphiljblendaojncdniiflinefkk/' target='_blank' rel='noopener noreferrer' className='w-full md:w-auto'>
                  <button className='w-full md:w-auto bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-10 py-4 rounded-xl text-lg font-semibold flex items-center justify-center gap-3 shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-200'>
                    <FontAwesomeIcon icon={faChrome} className='w-6 h-6' />
                    {locales.landingAddToChrome[globalSettings.lang]}
                  </button>
                </a>
                <a href='https://github.com/NekoTranslate/nekotranslate-browser-extension' target='_blank' rel='noopener noreferrer' className='w-full md:w-auto'>
                  <button className='w-full md:w-auto bg-gradient-to-r from-gray-700 to-gray-900 hover:from-gray-800 hover:to-gray-950 text-white px-10 py-4 rounded-xl text-lg font-semibold flex items-center justify-center gap-3 shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-200'>
                    <FontAwesomeIcon icon={faGithub} className='w-6 h-6' />
                    {locales.landingViewOnGitHub[globalSettings.lang]}
                  </button>
                </a>
              </div>
              <p className='mt-6 text-sm text-purple-200'>
                {locales.landingAlsoCompatible[globalSettings.lang]}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id='features' className='py-16 bg-purple-50'>
        <div className='w-full px-4 sm:px-6 lg:px-8'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold text-gray-900'>
              {locales.landingPowerfulFeatures[globalSettings.lang]}
            </h2>
            <p className='mt-4 text-xl text-gray-600 max-w-3xl mx-auto'>
              {locales.landingEverythingYouNeed[globalSettings.lang]}
            </p>
          </div>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 sm:gap-8'>
            <div className='bg-white p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition'>
              <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                <GiftIcon className='h-6 w-6 text-purple-800' />
              </div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingTryBeforeRegistration[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingTryBeforeRegistrationDescription[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition'>
              <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                <ShieldCheckIcon className='h-6 w-6 text-purple-800' />
              </div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingRespectsPrivacy[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingRespectsPrivacyDescription[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition'>
              <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                <GlobeIcon className='h-6 w-6 text-purple-800' />
              </div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingWideLanguageSupport[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingWideLanguageSupportDescription[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition'>
              <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                <EyeIcon className='h-6 w-6 text-purple-800' />
              </div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingMangaOptimizedOcr[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingMangaOptimizedOcrDescription[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition'>
              <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                <AcademicCapIcon className='h-6 w-6 text-purple-800' />
              </div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingFlagshipLLMSupport[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingFlagshipLLMSupportDescription[globalSettings.lang]}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id='how-it-works' className='py-16 bg-white'>
        <div className='w-full px-4 sm:px-6 lg:px-8'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold text-gray-900'>
              {locales.landingHowItWorks[globalSettings.lang]}
            </h2>
            <p className='mt-4 text-xl text-gray-600 max-w-3xl mx-auto'>
              {locales.landingHowItWorksDescription[globalSettings.lang]}
            </p>
          </div>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8'>
            <div className='text-center'>
              <div className='bg-purple-800 h-16 w-16 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4'>1</div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingAddManga[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingAddMangaDescription[globalSettings.lang]}
              </p>
            </div>
            <div className='text-center'>
              <div className='bg-purple-800 h-16 w-16 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4'>2</div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingChooseTargetLanguage[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingChooseTargetLanguageDescription[globalSettings.lang]}
              </p>
            </div>
            <div className='text-center'>
              <div className='bg-purple-800 h-16 w-16 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4'>3</div>
              <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                {locales.landingGetTranslation[globalSettings.lang]}
              </h3>
              <p className='text-gray-600'>
                {locales.landingGetTranslationDescription[globalSettings.lang]}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id='faq' className='py-16 bg-purple-50'>
        <div className='w-full px-4 sm:px-6 lg:px-8'>
          <div className='text-center mb-12'>
            <h2 className='text-3xl font-bold text-gray-900'>
              {locales.landingFAQ[globalSettings.lang]}
            </h2>
          </div>
          <div className='space-y-6'>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQLanguagesQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQLanguagesAnswer[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQAccuracyQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQAccuracyAnswer[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQStorageQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQStorageAnswer[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQFormatsQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQFormatsAnswer[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQChargeQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQChargeAnswer[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQLimitationsQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQLimitationsAnswer[globalSettings.lang]}
              </p>
            </div>
            <div className='bg-white p-6 rounded-lg border border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                {locales.landingFAQResetPasswordQuestion[globalSettings.lang]}
              </h3>
              <p className='mt-2 text-gray-600'>
                {locales.landingFAQResetPasswordAnswer[globalSettings.lang]}
              </p>
            </div>
          </div>
        </div>
      </div>
      <CTA
        subText={locales.landingCTASubText[globalSettings.lang]}
        globalSettings={globalSettings}
      />
      <Footer
        globalSettings={globalSettings}
      />
    </div>
  );
};
export default Landing;

